module.exports = __webpack_public_path__ + "img/aboutUsImg.7afcefe7.jpg";